import React from 'react';

import {CircularProgress} from "@mui/joy";
import Box from '@mui/joy/Box';
import Typography from "@mui/joy/Typography";

// components
import UltimateAdminEditModal from "./UltimateAdminEditModal";
import BaseApi from "../../../utils/BaseApi";
import {deleteArrayItemByKeyValue, downloadBlob, objectFilter} from "../../../utils/misc";
import CommonPaginatedTable from "../../Common/CommonPaginatedTable";
import UltimateAdminCreateModal from "./UltimateAdminCreateModal";
import CommonCallBackButton from "../../Common/CommonCallBackButton";

// icons
import DeleteIcon from "@mui/icons-material/Delete";
import CachedIcon from '@mui/icons-material/Cached';


class UltimateAdminList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            pages: null,
            pageNumber: 1,
            filters: {},
            filterFields: null,
            formFields: null,
            config: null,
        };
    }

    async componentDidMount() {
        if (this.props.model){
            await this.retrieveData();
            await this.retrieveAllFields();
            await this.retrieveConfig();
        }
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            if (this.props.model){
                await this.retrieveData();
                await this.retrieveAllFields();
                await this.retrieveConfig();
            }
        }
    }

    async retrieveAllFields() {
        let formFields = await this.retrieveFields()
        this.setState(
            {
                filterFields: formFields.filter(
                    f => (['select', 'multiselect', 'checkbox'].includes(f.type))
                ).map(f => {
                    f.required = false;
                    return f
                }),
                formFields: formFields
            }
        );
    }

    async retrieveConfig() {
        const api = new BaseApi();
        const url = `admin/`;
        let config = {
            listFields: [],
            filters: [],
            searchFields: [],
        }
        const params = {
            model: 'AdminConfig',
            xmodel: this.props.model.toLowerCase()
        }
        let response = await api.get(
            url,
            params
        );
        if (response.data.results?.length){
            config = response.data.results[0].config
        }
        this.setState({
            config: config
        })
    }

    async retrieveFields() {
        const url = `admin/update_form/`;
        const params = {
            model: this.props.model
        }
        const api = new BaseApi();
        let response = await api.get(
            url,
            params
        );
        let formFields = response.data
        formFields = deleteArrayItemByKeyValue(
            formFields,
            'name',
            'system_title',
        );
        return(formFields)
    }

    async retrieveData(page=1) {
        this.setState(
            {
                data: null,
                pages: null,
            }
        );
        const url = 'admin/';
        const api = new BaseApi();
        let params = {
            model: this.props.model,
            page: page
        }
        params = {...params, ...this.state.filters};
        let response = await api.get(url, params);
        if (response.status === 404){
            params['page'] = 1;
        }
        response = await api.get(url, params);
        this.setState(
            {
                data: response.data.results,
                pages: response.data.total_pages,
                pageNumber: page,
            }
        );
    }

    async filterCallBack(filters) {
        filters = objectFilter(
            filters,
            (e) => (e !== '' || !!e)
        )
        await this.setState({
            filters: filters
        });
        await this.retrieveData();
    }

    async downloadCallBack() {
        const api = new BaseApi();
        const url = `admin/list_download/`;
        let params = {
            model: this.props.model
        }
        params = {...params, ...this.state.filters};
        if (this.state.pageNumber){
            params['page'] = this.state.pageNumber;
        }
        let response = await api.get(url, params);
        if (response.status === 404){
            params['page'] = 1;
        }
        response = await api.get(url, params);
        downloadBlob(
            [response.data, ],
            `${this.props.model}.csv`
        )
    }

    async destroy(id){
        const api = new BaseApi();
        let url = `admin/${id}/?model=${this.props.model}`;
        await api.delete(url);
        await this.retrieveData();
    }

    render() {
        if (!this.props.model){
            return (
                <Typography>
                    Укажите модель
                </Typography>
            )
        }
        if (!this.state.data || !this.state.pages || !this.state.filterFields || !this.state.formFields || !this.state.config) {
            return (<CircularProgress/>)
        }
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    my: 1,
                    gap: 1,
                    flexWrap: 'wrap',
                    '& > *': {
                        minWidth: 'clamp(0px, (500px - 100%) * 999, 100%)',
                        flexGrow: 1,
                    },
                }}
            >
                <CommonPaginatedTable
                    key={crypto.randomUUID()}
                    title={this.props.model}
                    data={this.state.data}
                    extraComponents={[
                        {
                            component: CommonCallBackButton,
                            componentProps: {
                                propsObject: 'componentObj',
                                propsObjectKey: 'id',
                                label: 'Обновить',
                                icon: CachedIcon,
                                color: 'primary',
                                variant: 'soft',
                            },
                            callBack: this.retrieveData.bind(this),
                        },
                        {
                            component: UltimateAdminCreateModal,
                            componentProps: {
                                model: this.props.model,
                                formFields: this.state.formFields,
                            },
                            callBack: this.retrieveData.bind(this),
                        },

                    ]}
                    pages={this.state.pages}
                    pageNumber={this.state.pageNumber}
                    pagesCallback={this.retrieveData.bind(this)}
                    download={{
                        callBack: this.downloadCallBack.bind(this),
                    }}
                    filterCallBack={this.filterCallBack.bind(this)}
                    filterFields={this.state.filterFields}
                    fields={[
                        {
                            title: 'ID',
                            name: 'id',
                            visible: true,
                        },
                        {
                            title: 'Техническое название',
                            name: 'system_title',
                            visible: true,
                        },
                        ...this.state.config.listFields.map(
                            (f) => (
                                {
                                    title: f,
                                    name: f,
                                    visible: true,
                                }
                            )
                        ),
                        {
                            title: '',
                            visible: true,
                            component: UltimateAdminEditModal,
                            componentProps: {
                                model: this.props.model,
                                formFields: this.state.formFields,
                                callBack: this.retrieveData.bind(this),
                            },
                        },
                        {
                            title: '',
                            visible: true,
                            component: CommonCallBackButton,
                            componentProps: {
                                propsObject: 'componentObj',
                                propsObjectKey: 'id',
                                icon: DeleteIcon,
                                color: 'danger',
                            },
                            callBack: this.destroy.bind(this),
                        }

                    ]
                    }
                />
            </Box>
        )
    }
}

export default UltimateAdminList
